import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from 'axios'
import {stopLoading} from '../FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../Utils/_helpers/EnvHelper'

const initialState: any = {
  QuickMsg: '',
  ContactOption: [],
  QuickMsgDraftData: {
    camp_type: 'sms',
    sender: '',
    contacts: [],
    subject: '',
    media: '',
    message: '',
    optout: false,
    alphaId: '',
    gif: '',
    longUrl: [],
    replyStopToOptOut: true,
  },
}

const API_URL = ENV().REACT_APP_API_URL

export const GetContactSearch: any = createAsyncThunk(
  'GetContactSearch',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}gateway/getSearchedContacts?search=${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const Quickmsg = createSlice({
  name: 'Quickmsg',
  initialState,
  reducers: {
    QuickMsg: (state, {payload}) => {
      return {...state, QuickMsg: payload}
    },
    QuickMsgDraftData: (state, {payload}) => {
      return {...state, QuickMsgDraftData: payload}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetContactSearch.fulfilled, (state, action) => {
      const ContactOptionList = action.payload?.data?.items?.map((key: any) => {
        const findSerach = ['fullname', 'firstname', 'name', 'lastname', 'birthday']?.find(
          (val1: any) =>
            key?.fields?.find(
              (val: any) => val?.name.toLowerCase().trim().replace(/\s+/g, '') == val1
            )
        )
        let name = key?.fields?.find(
          (val1: any) => findSerach == val1?.name.toLowerCase().trim().replace(/\s+/g, '')
        )?.value

        if (name) {
          return {value: key?.number, label: `${name}-${key?.number}`}
        } else {
          return {value: key?.number, label: `${key?.number}`}
        }
      })

      return {...state, ContactOption: ContactOptionList}
    })
  },
})

export const {QuickMsg, QuickMsgDraftData} = Quickmsg.actions
export const OptionList = (state: any) => state?.quickMsg?.ContactOption

export default Quickmsg.reducer
